require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-category-blog-category-latest-stories.json") })
        }
      }, "path---blog-category-blog-category-latest-stories");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-category-blog-category-latest-stories!./.cache/json/blog-category-blog-category-latest-stories.json
// module id = 732
// module chunks = 231608221292675